export const formatDomainName = input => {
  if (!input) return
  
  if (input.endsWith('.drift.help')) {
    return input.substring(0, input.length - 11)
  }
  
  return input
}